<template>
	<TnCard
		border
		dashed
		class="card"
	>
		<template
			v-if="badge"
			#badge
		>
			<TnBadge
				size="m"
				responsive
			>
				{{ badge }}
			</TnBadge>
		</template>

		<div class="card__content">
			<div
				v-if="image"
				class="card__content__graphic"
			>
				<ImageResponsive v-bind="image" />
			</div>
			<div>
				<TnParagraph
					v-if="heading"
					bold
					responsive
					size="l"
					class="inbytte-text"
				>
					{{ heading }}
				</TnParagraph>
				<TnParagraph
					v-if="subHeading"
					responsive
					size="l"
					class="inbytte-text"
				>
					{{ subHeading }}
				</TnParagraph>
			</div>
		</div>

		<div>
			<TnButton
				v-if="button"
				class="margin-top-m"
				responsive
				secondary
				@click="goToTradeIn"
			>
				{{ button }}
			</TnButton>
		</div>
	</TnCard>
</template>

<script setup lang="ts">
import type { InfoForTheTradeInCard } from "~/components/hardware-concepts/TradeIn/GizmoTradeInCard/tradeincard.d.ts";

const { tradeInUrl } = defineProps({
	badge: {
		type: String,
		default: undefined,
	},
	heading: {
		type: String,
		default: undefined,
	},
	subHeading: {
		type: String,
		default: undefined,
	},
	button: {
		type: String,
		default: undefined,
	},
	image: {
		type: Object as PropType<InfoForTheTradeInCard["tradeInCardImage"]>,
		default: undefined,
	},
	tradeInUrl: {
		type: String,
		default: "/mobiltelefoner/innbytte/bestill/",
	},
});

const route = useRoute();

const goToTradeIn = () => {
	navigateTo({ path: tradeInUrl, query: { path: route.path } });
};
</script>

<style scoped lang="scss">
.inbytte-text {
	color: $color-neutrals-black;
}

.card {
	padding: $spacing-2xl $spacing-m $spacing-m;
	display: flex;
	flex-direction: column;

	&__content {
		display: flex;
		flex-direction: row;

		&__graphic {
			display: flex;
			justify-content: center;
			align-items: center;
			width: 60px;
			height: 60px;
			flex-shrink: 0;
			flex-grow: 0;

			:deep(> *) {
				max-height: 100%;
				max-width: 100%;
			}
		}
	}
}
</style>
